import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft";
import PostShare from "./components/PostShare/PostShare";
import StoryShare from "./components/StoryShare/StoryShare";
function isMobileDevice() {
    if (typeof navigator === "undefined") {
        return false;
    }
    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true;
    }
    // iPadOS reports a desktop "Macintosh" user agent, so fall back to a touch-point check.
    return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 0;
}
function buildShareData(url, imageBlob) {
    var _a;
    if (!imageBlob) {
        return { url };
    }
    const file = new File([imageBlob], "chuffed-share-image.png", { type: "image/png" });
    return ((_a = navigator.canShare) === null || _a === void 0 ? void 0 : _a.call(navigator, { files: [file] })) ? { url, files: [file] } : { url };
}
function InstagramShare({ shareItem, onBack, canNativeShare, type, isStory = false, }) {
    return (_jsxs("div", { className: "share-modal__instagram-view", children: [_jsxs("button", { type: "button", onClick: onBack, className: "share-modal__back", children: [_jsx(FiArrowLeft, {}), "Back"] }), isStory ? (_jsx(StoryShare, { shareItem: shareItem, canNativeShare: canNativeShare, isMobileDevice: isMobileDevice(), type: type, buildShareData: buildShareData })) : (_jsx(PostShare, { shareItem: shareItem, canNativeShare: canNativeShare, isMobileDevice: isMobileDevice(), type: type, buildShareData: buildShareData }))] }));
}
export default InstagramShare;
